import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useTranslation } from '../hooks/useTranslation';
import DatenschutzPageRU from './DatenschutzPageRU';

export default function DatenschutzPage() {
  const { isRussian, currentLanguage } = useTranslation();
  
  // Отладочная информация
  console.log('DatenschutzPage - currentLanguage:', currentLanguage, 'isRussian:', isRussian);
  console.log('DatenschutzPage - typeof isRussian:', typeof isRussian);
  
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  // Показываем русскую версию если язык русский
  if (isRussian) {
    return <DatenschutzPageRU />;
  }

  return (
    <div className="min-h-screen bg-white text-dark-900">
      <Header />
      <main className="pt-16 sm:pt-20">
        <motion.section
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="py-8 sm:py-16 lg:py-20"
        >
          <div className="max-w-4xl mx-auto px-3 sm:px-4 lg:px-8">
            <motion.div variants={item} className="text-center mb-8 sm:mb-12">
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 text-dark-900">
                Datenschutzerklärung
              </h1>
              <p className="text-base sm:text-lg text-gray-600">
                Datum: 20. September 2025
              </p>
            </motion.div>

            <motion.div variants={item} className="prose prose-sm sm:prose-lg max-w-none">
              <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">1. Allgemeine Hinweise zum Datenschutz</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Der Betreiber dieser Website nimmt den Schutz Ihrer persönlichen Daten sehr ernst. Ich behandle Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Die Analyse Ihres Surfverhaltens erfolgt in der Regel anonymisiert; das Surfverhalten kann nicht zu Ihnen zurückverfolgt werden. Sie können dieser Analyse widersprechen oder sie durch die Nichtbenutzung bestimmter Tools verhindern.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">2. Allgemeine Hinweise und Pflichtinformationen</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Datenschutz</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Der Betreiber dieser Website nimmt den Schutz Ihrer persönlichen Daten sehr ernst. Ich behandle Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Bei der Nutzung dieser Website werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 sm:mb-6">
                  Ich weise darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Verantwortliche Stelle</h3>
                <div className="bg-gray-50 rounded-lg sm:rounded-xl p-3 sm:p-4 mb-4 sm:mb-6">
                  <p className="text-sm sm:text-base text-gray-700 font-medium mb-2">Verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
                  <div className="text-sm sm:text-base text-gray-700">
                    <p><strong>Alfira Herrmann</strong></p>
                    <p>Hochburgerstr. 32</p>
                    <p>79312 Emmendingen</p>
                    <p>Tel: +49 (0) 7641 95 37 645</p>
                    <p>E-Mail: alphavita@gmx.de</p>
                  </div>
                </div>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Hosting</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Unsere Website wird bei einem professionellen Hosting-Anbieter gehostet. Die Daten werden auf sicheren Servern gespeichert und entsprechen höchsten Sicherheitsstandards.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu genügt eine formlose Mitteilung per E-Mail an uns.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">SSL- bzw. TLS-Verschlüsselung</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Recht auf Auskunft, Sperrung, Löschung</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">3. Datenerfassung auf unserer Website</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Cookies</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Die Internetseiten verwenden teilweise sogenannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Die meisten der von uns verwendeten Cookies sind so genannte „Session-Cookies". Sie werden nach Ende Ihres Besuchs automatisch gelöscht.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Server-Log-Dateien</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
                </p>
                <ul className="list-disc list-inside text-sm sm:text-base text-gray-700 mb-3 sm:mb-4 space-y-1">
                  <li>Browsertyp und Browserversion</li>
                  <li>verwendetes Betriebssystem</li>
                  <li>Referrer-URL</li>
                  <li>Hostname des zugreifenden Rechners</li>
                  <li>Uhrzeit der Serveranfrage</li>
                  <li>IP-Adresse</li>
                </ul>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Kontaktformular</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Wenn Sie uns Anfragen per Kontaktformular zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten gebe ich nicht ohne Ihre Einwilligung weiter.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">4. Soziale Medien und externe Links</h2>
                
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Unsere Website verwendet Plugins und Schaltflächen, die es ermöglichen, Inhalte in sozialen Netzwerken wie WhatsApp, Facebook, LinkedIn, Instagram und anderen zu teilen.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Bitte beachten Sie: Sobald Sie auf einen externen Link klicken, unterliegen die Erfassung und Verarbeitung Ihrer Daten den Datenschutzrichtlinien des jeweiligen sozialen Netzwerks. Ich übernehme keine Verantwortung für die Erhebung und Nutzung Ihrer Daten auf diesen Plattformen.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Um Informationen darüber zu erhalten, wie diese Websites Ihre Daten verarbeiten, lesen Sie bitte deren Datenschutzrichtlinien:
                </p>
                <ul className="list-disc list-inside text-sm sm:text-base text-gray-700 space-y-1">
                  <li><a href="https://www.whatsapp.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">WhatsApp: Datenschutzrichtlinien von WhatsApp</a></li>
                  <li><a href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">Facebook: Datenschutzrichtlinien von Facebook</a></li>
                  <li><a href="https://www.linkedin.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">LinkedIn: Datenschutzrichtlinien von LinkedIn</a></li>
                  <li><a href="https://privacycenter.instagram.com/policy/?entry_point=ig_help_center_data_policy_redirect" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">Instagram: Datenschutzrichtlinien von Instagram</a></li>
                </ul>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">5. Analyse-Tools und Werbung</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Google Analytics</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Google Analytics verwendet sogenannte „Cookies". Das sind Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Ich habe auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum vor der Übermittlung in die USA gekürzt.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">6. Plugins und Tools</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Google Web Fonts</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten sogenannte Web Fonts, die von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web Fonts in ihren Browser-Cache, um Texte und Schriftarten korrekt anzuzeigen.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">Google Maps</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Diese Seite nutzt über eine API den Kartendienst Google Maps. Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP-Adresse zu speichern. Diese Informationen werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert.
                </p>
              </div>

              <div className="bg-rose-50 border border-rose-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Fragen zum Datenschutz</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Wenn Sie Fragen zum Datenschutz haben, schreiben Sie mir bitte an: alphavita(@)gmx.de
                </p>
                <p className="text-xs sm:text-sm text-gray-500 mt-3 sm:mt-4">
                  Emmendingen, 20. September 2025
                </p>
              </div>
            </motion.div>
          </div>
        </motion.section>
      </main>
      <Footer />
    </div>
  );
}
